import { KeyboardEvent, KeyboardEventHandler } from 'react'

export const preventKeyDown: KeyboardEventHandler<HTMLFormElement> = (e) => {
  e.key === 'Enter' && !(e.target instanceof HTMLTextAreaElement) && e.preventDefault()
}

/**
 * IME（日本語入力）の変換確定中かどうか。
 *
 * 日本語入力では「スペースで変換 → Enter で確定」という操作をする。この確定用の Enter も
 * keydown として発火するため、素で `e.key === 'Enter'` を見ると**変換を確定した瞬間に
 * 送信が走る**（＝入力途中の文字が送られる誤送信になる）。
 * 変換中は `isComposing` が true になるので、送信判定の前にこれで弾く。
 *
 * `isComposing` は React の合成イベントには無いため `nativeEvent` から取る。
 * 一部の環境では isComposing が来ないことがあるので、旧来の keyCode 229 も併せて見る。
 */
export const isComposing = <T extends Element>(e: KeyboardEvent<T>): boolean => {
  const native = e.nativeEvent as unknown as { isComposing?: boolean; keyCode?: number }
  return native?.isComposing === true || native?.keyCode === 229
}

/**
 * 変換確定ではない、純粋な Enter 押下かどうか。
 *
 * 検索やタグ追加のように Enter で実行するのが自然な操作に使う。
 * AI呼び出しなど実行にコストがかかる操作は Enter に割り当てず、ボタンだけにする
 * （Enter は習慣で押してしまうため）。
 */
export const isEnterWithoutComposing = <T extends Element>(e: KeyboardEvent<T>): boolean =>
  e.key === 'Enter' && !isComposing(e)
